var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMatchmaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "68.000000pt",
    height: "57.000000pt",
    viewBox: "0 0 68.000000 57.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,57.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 448 c-10 -18 -8 -24 7 -37 19 -15 19 -17 2 -33 -13 -13 -18 -33 -18 -69 0 -73 12 -89 65 -89 l44 0 3 -47 c3 -40 6 -48 23 -48 18 0 20 7 20 70 l0 70 -32 3 c-25 2 -33 8 -33 22 0 14 9 20 37 22 48 4 59 34 16 43 -15 3 -43 13 -61 22 -27 14 -30 18 -17 25 18 11 20 39 3 56 -19 19 -46 14 -59 -10z m46 -9 c10 -15 -1 -23 -20 -15 -9 3 -13 10 -10 16 8 13 22 13 30 -1z m21 -83 c11 -8 31 -16 44 -19 14 -2 6 -3 -18 -2 -35 2 -42 0 -38 -12 3 -8 6 -28 6 -44 0 -27 3 -29 35 -29 l35 0 -2 -57 -2 -58 -3 52 -4 52 -52 3 -52 3 -3 49 c-5 76 10 93 54 62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 456 c-19 -22 -4 -56 23 -56 32 0 53 26 39 48 -14 23 -47 27 -62 8z m44 -16 c3 -6 -1 -13 -10 -16 -19 -8 -30 0 -20 15 8 14 22 14 30 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 379 c-7 -7 -29 -15 -50 -18 -29 -5 -38 -11 -38 -26 0 -16 8 -21 38 -23 28 -2 37 -8 37 -22 0 -14 -8 -20 -32 -22 l-33 -3 0 -70 c0 -63 2 -70 20 -70 17 0 20 8 23 48 l3 47 43 0 c23 0 47 5 54 12 16 16 16 130 0 146 -15 15 -51 15 -65 1z m52 -74 l0 -60 -52 -3 -52 -3 -4 -52 -3 -52 -2 58 -2 57 35 0 c33 0 35 2 35 34 0 19 5 38 10 41 6 4 7 11 4 17 -4 6 -10 6 -17 -1 -6 -6 -27 -10 -46 -10 -34 2 -34 2 -6 6 16 3 38 11 50 19 38 27 50 14 50 -51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 286 c0 -57 3 -67 25 -84 28 -22 35 -72 10 -72 -8 0 -15 -4 -15 -10 0 -5 20 -10 45 -10 46 0 61 14 25 23 -12 3 -20 14 -20 26 0 17 6 21 30 21 17 0 30 5 30 10 0 6 -15 10 -33 10 -18 0 -43 7 -55 16 -19 13 -22 24 -22 75 0 33 -4 59 -10 59 -6 0 -10 -28 -10 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 291 c0 -68 -10 -80 -69 -88 -43 -6 -47 -23 -5 -23 31 0 34 -39 4 -47 -11 -3 -17 -9 -14 -14 7 -12 84 -11 84 1 0 6 -7 10 -15 10 -25 0 -18 50 10 72 22 17 25 27 25 84 0 36 -4 64 -10 64 -6 0 -10 -26 -10 -59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 290 c-4 -6 17 -10 54 -10 l61 0 0 -75 c0 -74 0 -75 -26 -75 -14 0 -23 -4 -19 -10 3 -5 30 -10 60 -10 30 0 57 5 60 10 4 6 -5 10 -19 10 -26 0 -26 1 -26 75 l0 75 60 0 c33 0 60 4 60 10 0 6 -50 10 -129 10 -76 0 -132 -4 -136 -10z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchmaking);
export default __webpack_public_path__ + "static/media/matchmaking.fdcfa352a0b4eda25134f500916dfea4.svg";
export { ForwardRef as ReactComponent };